'use strict'
var values = require('./values')
module.exports = function (object) {
  return values(Object.keys(object))
}





//////////////////
// WEBPACK FOOTER
// ./node_modules/pull-stream/sources/keys.js
// module id = M/Si
// module chunks = 0